export default {
  title: 'purple',

  twitter: '#794bc4',
    twitter_dark_hover: 'rgba(121, 75, 196, .1)',
    twitter_light_hover: '#8660ca',
}